export const Colors = {
  Purple: '#673AFF',
  PurpleDisabled: '#673AFF40',
  LightPurple: '#808CF4',
  Grey92: '#E0E0E1',
  Grey92Light: '#E0E0E165',
  Grey60: '#97979B',
  Grey50: '#7A7C85',
  Black26: '#41424B',
  Black22: '#373842',
  Black18: '#2E3038',
  Black15: '#292A32',
  Black12: '#202128',
  Yellow: '#D79053',
  YellowLight: '#6B5040',
  Yellow2: '#B08B69',
  Red: '#CA4365',
  Transparent: 'transparent',
};
